import { certificate, detailedExplanations, doubtSupport, highQualityLectures, industryCurriculum, lifetimeAccess, pocketFriendlyCourses, practiceProblems } from "../assets"

export const whyCMData = [
    {
        id: 1,
        title: 'Pocket friendly courses',
        image: pocketFriendlyCourses,
    },
    {
        id: 2,
        title: 'HD Videos & Crystal clear audios',
        image: highQualityLectures,
    },
    {
        id: 3,
        title: 'Intuitive & Detailed Explanations',
        image: detailedExplanations,
    },
    {
        id: 4,
        title: 'Practice codes, real time feedback',
        image: practiceProblems,
    },
    {
        id: 5,
        title: 'Industry vetted curriculum',
        image: industryCurriculum,
    },
    {
        id: 6,
        title: 'Lifetime access, anytime anywhere',
        image: lifetimeAccess,
    },
    {
        id: 7,
        title: 'Unlimited doubt support',
        image: doubtSupport,
    },
    {
        id: 8,
        title: 'Certificate of completion',
        image: certificate,
    }

]